module.exports = __webpack_public_path__ + "img/cx.14b1b5a0.svg";